import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "exportProductDEPBProductgroup",
          label: "Product Group",
          component: "dropdown",
          endIconName: "LuChevronDown",
          options: [
            { label: "Engineering Products", value: "Engineering Products" },
            { label: "Chemicals and allied", value: "Chemicals and allied" },
            { label: "Plastics", value: "Plastics" },
            { label: "Leather and Leather", value: "Leather and Leather" },
            { label: "Sports Goods", value: "Sports Goods" },
            {label : "FIS AND FISH PRODUCTS" , value : "FIS AND FISH PRODUCTS"},
          ],
        },
        {
          name: "exportProductRateList",
          label: "Rate List Sr No",
          component: "text-field",
          icon: LuSearch,
          type: "autocomplete",
          endpoint: "getRateListMaster",
        },
      ],
      row2: [
        {
          name: "exportProductDEPBRate",
          label: "DEPB Rate",
          component: "text-field",
          width: "20%",
          placeholder: "0.00",
          dataType : "int"
        },

        {
          name: "exportProductDEPBQty",
          label: "DEPB Qty",
          component: "text-field",
          width: "20%",
          placeholder: "0.00",
          dataType : "int"
        },
        {
          name: "exportProductDEPBUnit",
          label: "Unit",
          component: "text-field",
          icon: LuSearch,
          width: "20%",
          type : "autocomplete",
         endpoint : "getQuantity"
        },
        {
          name: "exportProductDEPBUnitQty",
          label: "% Qty",
          component: "text-field",
          width: "20%",
          placeholder: "0.00",
          dataType : "int"  
        },
        {
          name: "exportProductCapValue",
          label: "CAP Value",
          component: "text-field",
          width: "20%",
          disabled : true
        },
      ],
    },
  },
]
};
